function registerExtensions() {
    Date.prototype.addHours = function (h) {
        var date = new Date(this);
        date.setHours(this.getHours() + h);
        return date;
    }
    Date.prototype.addMinutes = function (m) {
        var date = new Date(this);
        date.setMinutes(this.getMinutes() + m);
        return date;
    }

    Array.prototype.firstOrDefault = function (f) {
        return this.filter(f)[0] || {};
    }
}

export {
    registerExtensions
}